module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Play-d2df144c11b9883bae8c2f10dab1e66c.svg";